export const getResourceSchedulingState = (state) => state.scheduling.resources;
